<script>
	// From Lucide
	import { GripVertical } from 'lucide-svelte';

	export let iconClass = '';
</script>

<GripVertical class={iconClass} />
